export const ARCANA_ACHIEVEMENTS = [
  'PARAMOUNT_PERFORMANCE',
  'ENLIGHTENEMENT',
  'ACE_IN_A_DAY',
  'RUINING_THE_CURVE',
];
